import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=3ae67dce&scoped=true"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"
import style0 from "./PlayerInfo.vue?vue&type=style&index=0&id=3ae67dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae67dce",
  null
  
)

export default component.exports